export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface Toast {
    id: string;
    message: string;
    type: ToastType;
    duration?: number;
}

type ToastListener = (toast: Toast) => void;

export class ToastService {
    private static instance: ToastService;
    private listeners: ToastListener[] = [];

    private constructor() { }

    static getInstance(): ToastService {
        if (!ToastService.instance) {
            ToastService.instance = new ToastService();
        }
        return ToastService.instance;
    }

    subscribe(listener: ToastListener): () => void {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }

    show(message: string, type: ToastType = 'info', duration: number = 5000) {
        const toast: Toast = {
            id: Math.random().toString(36).substring(2, 9),
            message,
            type,
            duration
        };
        this.notify(toast);
    }

    success(message: string, duration?: number) {
        this.show(message, 'success', duration);
    }

    error(message: string, duration?: number) {
        this.show(message, 'error', duration);
    }

    info(message: string, duration?: number) {
        this.show(message, 'info', duration);
    }

    warning(message: string, duration?: number) {
        this.show(message, 'warning', duration);
    }

    private notify(toast: Toast) {
        this.listeners.forEach(listener => listener(toast));
    }
}
